import { atom, useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const storageKey = 'enableSessionTimeout';

const strAtomWithStorage = atomWithStorage(storageKey, '');

// tri-state: undefined means never set, distinct from an explicit false.
const triStateAtom = atom(
  get => {
    const raw = get(strAtomWithStorage);
    if (raw === 'true') return true;
    if (raw === 'false') return false;
    return undefined;
  },
  (_, set, val: boolean | undefined) => {
    if (val === undefined) set(strAtomWithStorage, '');
    else set(strAtomWithStorage, val ? 'true' : 'false');
  },
);

const useEnableSessionTimeout = () => useAtom(triStateAtom);

export default useEnableSessionTimeout;
